import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNewPerformRules as _getNewPerformRules, getNewPerformRuleTypes as _getNewPerformRuleTypes, delNewPerformRule, setNewPerformAdjust } from '@/api/goodsCenter';
import AddPerformAdjustRule from './performComponents/addPerformAdjustRule.vue';
import CinemaRangeDialog from './components/cinemaRangeDialog.vue';
export default {
  name: 'newPerformAdjustRuleList',
  components: {
    AddPerformAdjustRule: AddPerformAdjustRule,
    CinemaRangeDialog: CinemaRangeDialog
  },
  data: function data() {
    return {
      totalCount: 0,
      create_time: [],
      update_time: [],
      ruleForm: {
        rule_id: '',
        rule_name: '',
        rule_type: '',
        creator: '',
        updater_id: '',
        company_name: '',
        s_created_time: '',
        e_created_time: '',
        s_updated_time: '',
        e_updated_time: '',
        selected_standard_ids: '',
        type: 'search',
        page: 1,
        pagesize: 20
      },
      ruleTypes: [],
      ruleList: [],
      pages: {}
    };
  },
  computed: {
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    }
  },
  props: {
    trendParamsGood: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  created: function created() {
    this.getNewPerformRules();
    this.getNewPerformRuleTypes();
  },
  methods: {
    log: function log() {
      this.$router.push({
        name: 'newPerformAdjustLog'
      });
    },
    // 查询规则列表
    searchRule: function searchRule() {
      this.ruleForm.page = 1;
      this.getNewPerformRules();
    },
    // 获取影院规则列表
    getNewPerformRules: function getNewPerformRules() {
      var _this = this;
      var params = this.ruleForm;
      if (this.trendParamsGood && this.trendParamsGood.rule_id) {
        params.rule_id = this.trendParamsGood.rule_id;
        params.company_name = this.trendParamsGood.company_name;
      }
      _getNewPerformRules(params).then(function (res) {
        _this.ruleList = res.data.data.data;
        _this.totalCount = res.data.data.totalCount;
      });
    },
    // 获取规则类型
    getNewPerformRuleTypes: function getNewPerformRuleTypes() {
      var _this2 = this;
      _getNewPerformRuleTypes().then(function (res) {
        _this2.ruleTypes = res.data.data.rule_types;
      });
    },
    // 搜索框时间处理
    changeTime: function changeTime(val, flag) {
      if (flag) {
        this.ruleForm.s_updated_time = val ? val[0] : '';
        this.ruleForm.e_updated_time = val ? val[1] : '';
      } else {
        this.ruleForm.s_created_time = val ? val[0] : '';
        this.ruleForm.e_created_time = val ? val[1] : '';
      }
    },
    // 打开调价规则
    openAdjustRuleDialog: function openAdjustRuleDialog(type, row) {
      if (type == 'edit') {
        var event = this.$refs.addPerformAdjustRule;
        event.ruleType = type == 'edit' ? row.rule_type : '';
        event.rule_id = row.rule_id;
        event.getEditInfo();
      } else {
        var _event = this.$refs.addPerformAdjustRule;
        _event.ruleType = 'add';
        _event.getList();
      }
    },
    openRangeDialog: function openRangeDialog(type, row) {
      var event = this.$refs.cinemaRange;
      event.rule_id = row.rule_id;
      event.type = type;
      event.moduleType = 'cakestore';
      event.getList();
    },
    // 保存设置规则
    emitSubmit: function emitSubmit(params) {
      var _this3 = this;
      setNewPerformAdjust(params).then(function (res) {
        var event = _this3.$refs.addPerformAdjustRule;
        _this3.$message.success('保存成功');
        event.dialogVisible = false;
        _this3.getNewPerformRules();
      });
    },
    delRule: function delRule(row) {
      var _this4 = this;
      this.$confirm("\u60A8\u786E\u5B9A\u8981\u5220\u9664\u89C4\u5219\u5417\uFF1F", '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        delNewPerformRule({
          rule_id: row.rule_id
        }).then(function (res) {
          _this4.ruleList.splice(_this4.ruleList.indexOf(row), 1);
          _this4.$message.success('操作成功');
        });
      });
    },
    // 规则列表table 规则展示条件
    showRule: function showRule(adjust_type) {
      if (adjust_type.length == 2) {
        return 'all';
      } else if (adjust_type[0] == 1) {
        // 按比例
        return 'ratio';
      } else if (adjust_type[0] == 2) {
        // 按金额
        return 'money';
      } else {
        return '';
      }
    },
    // 分页操作
    onChange: function onChange(val) {
      this.ruleForm.page = val;
      this.getNewPerformRules();
    },
    resetRuleForm: function resetRuleForm() {
      this.ruleForm = {
        rule_id: '',
        rule_name: '',
        rule_type: '',
        creator: '',
        updater_id: '',
        company_name: '',
        s_created_time: '',
        e_created_time: '',
        s_updated_time: '',
        e_updated_time: '',
        selected_standard_ids: '',
        type: 'search',
        page: 1,
        pagesize: 20
      };
      this.create_time = [];
      this.update_time = [];
    }
  }
};